import React, { Component } from 'react';
import loadScripts from '../../../dassets/js/custom';
import { Link } from 'react-router-dom';

class PortfolioManagement extends Component {
  componentDidMount() {
    loadScripts();
  }
  render() {
    return (
      <>
        {/* =================================
    Inner Header */}
        <div className="inner-header bg-light">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-sm-6 text-sm-start mb-2 mb-sm-0">
                <h1 className="breadcrumb-title mb-0">Portfolio Management</h1>
              </div>
              <div className="col-sm-6">
                <ol className="breadcrumb d-flex justify-content-center justify-content-sm-end ms-auto">
                  <li className="breadcrumb-item"><Link to={"/"}><i className="fas fa-home me-1"></i>Home</Link></li>
              <li className="breadcrumb-item"><span>Services</span></li>
                  <li className="breadcrumb-item active"><span>Portfolio Management</span></li>
                </ol>
              </div>
            </div>
          </div>
        </div>
        {/* =================================
  Inner Header */}


        <section className="space-ptb">
          <div className="container">
            <div className="row">
              <div className="col-md-4 col-xl-3">
                <ul className="list-unstyled vertical-menu border border-2 rounded p-3">
                  <li><Link to={"/services/issuing-house"}><span>Issuing House</span></Link></li>
                  <li><Link to={"/services/stockbroking"}><span>Stockbroking</span></Link></li>
                  <li><Link to={"/services/financial-advisory"}><span>Financial Advisory</span></Link></li>
                  <li><Link className="active" to={"/services/portfolio-management"}><span>Portfolio Management</span></Link></li>
                  <li><Link to={"/services/fund-management"}><span>Fund Management</span></Link></li>
                  <li><Link to={"/services/lagos-commodities-and-future-exchange"}><span>Lagos Commodities and Future Exchange</span></Link></li>
                </ul>
                <div className="bg-dark rounded p-4 mb-md-0 mb-5">
                  <span className="lead text-primary fw-bold">Do you have a question? Please contact us</span>
                  <h6 className="text-white mt-3">+(234) 0805 555 0606</h6>
                  <span className="text-white">info@dynamicportfolio.com</span>
                </div>
              </div>
              <div className="col-md-8 col-xl-9">
                {/* <img className="img-fluid mb-4" src={require("./../../dassets/images/service/10.jpg")} alt=""/> */}
                <div className="mb-md-5 mb-4">
                  <h4 className="mb-4">Portfolio Management</h4>
                  <div className='mb-4'>
                    <p>The focus of Dynamic's Portfolio Management Services is to assemble appropriate mix of investment instruments that best meet your requirements in terms of safety, tenor and yield in addition to ensuring flexibility for appropriate rationalisation with a view to achieving maximum return on investment.</p><p>

                      Given the needs and preferences of the investor, Dynamic will work out a suitable basket of money and capital market instruments with short, medium to long term maturities, ranging from CBN Treasury bills, Bankers Acceptances and Commercial Papers to various categories of equity and debt instruments available in the market.  The structure of the mix is informed by a thorough in-depth analysis of trends and prospects in various industrial sectors and the general economic situation.</p><p>

                      On a continuous basis, the impact on the mix of various policy measures and developments in the economy are analysed and the investment portfolio rationalised in a manner consistent with the objectives of the investors.</p><p>

                      Upon its appointment as portfolio managers, Dynamic carries out an analysis of the existing investments of the fund to ascertain its adequacy against the background of the objectives of the fund.  </p><p>

                      On the basis of the result of the analysis, advice is provided on an optimum mix of instruments with particular reference not only to the highest rate of return but also the safety of such investment.  An investment strategy is then drawn up and implemented by Dynamic.</p><p>

                      In general, Dynamic adopts an investment policy that provides the highest yield over the anticipated period of investment with in-built flexibility for rationalization in line with possible economic changes in order to avoid a depreciation of the value of the investment.</p><p>

                      Dynamic will submit quarterly reports on its investment activities as deemed appropriate by the Investor.  These reports will serve as working documents at our quarterly review meetings.  Periodically, Dynamic issues to its clients an analysis of major developments in the economy that will impact on the investment climate, as a guide for possible review of investment strategy of the fund.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </>
    );
  }
}

export default PortfolioManagement;